import React, { Component } from 'react';
import LoadingIndicator from '../LoadingIndicator';

import './styles.css';

class LoadingMask extends Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'initial';
  }

  render() {
    return (
      <div className="LoadingMask">
        <LoadingIndicator />
        Carregando...
      </div>
    );
  }
}

export default LoadingMask;
